import { Box, Stack, Typography } from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';

export default function BaseSwitch({ sx, selected, onChange, options, activeColor, title }) {
  return (
    <Box>
      <Box
        sx={{
          display: title ? 'flex' : 'none',
          alignItems: 'center',
          mb: '8px'
        }}
      >
        <Typography variant="h4" color="primary.darkGray">
          {title}
        </Typography>
        <HelpIcon 
          sx={{
            fontSize: '20px',
            color: 'primary.mediumGray',
            ml: '8px'
          }}
        />
      </Box>
      <Box sx={{
        bgcolor: 'primary.lightGray',
        border: '1px solid #ABB7C0',
        borderRadius: '40px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        height: '39px',
        width: '100%',
        padding: '4px',
        ...sx
      }}>
        {options.map(option => (
          <Box
            key={option.title}
            sx={{
              width: '50%',
              height: '100%',
              background: selected === option.value ? activeColor : 'transparent',
              border: selected === option.value ? `1px solid ${activeColor}` : '1px solid transparent',
              borderRadius: '25px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
              // padding: selected === option.value ? { xs: '2px 3px', md: '2px 3px' } : { xs: '3px 0px', md: '3px 0px' },
            }}
            onClick={() => onChange(option.value)}
          >
            <Stack
              direction={'row'}
              spacing={'8px'}
              alignItems={'center'}
            >
              <Box
                sx={{
                  display: 'flex',
                  color: selected === option.value ? 'white' : 'primary.black',
                }}
              >
                {option?.icon}
              </Box>
              <Typography
                key={option.value}
                variant="h4"
                sx={{
                  color: selected === option.value ? 'white' : 'primary.black',
                  whiteSpace: 'nowrap'
                }}
              >
                {option.title}
              </Typography>
            </Stack>
          </Box>
        ))}
      </Box>
    </Box>
  )
}